import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    journal: [
      { title: 'About Us', path: '/about' },
      { title: 'Editorial Board', path: '/editorial-board' },
      { title: 'Editorial Team', path: '/editorial-team' },
      { title: 'Contact Us', path: '/contact' }
    ],
    authors: [
      { title: 'Author Guidelines', path: '/guide-for-authors' },
      { title: 'Submit Manuscript', path: '/submit-paper' },
      // { title: 'Manuscript Template', path: '/manuscript-template' },
      { title: 'Publication Charges', path: '/publication-charges' }
    ],
    resources: [
      { title: 'Current Issue', path: '/current-publications' },
      { title: 'Archives', path: '/archives' },
      { title: 'Special Issues', path: '/special-issues' },
      { title: 'Search Articles', path: '/search' }
    ],
    policies: [
      { title: 'Open Access Policy', path: '/open-access-policy' },
      { title: 'Copyright', path: '/copyright' },
      { title: 'Privacy Policy', path: '/privacy-policy' },
      { title: 'Ethics', path: '/ethics' },
      { title: 'Admin Portal', path: '/admin' }
    ]
  };

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-grid">
            {/* Brand Section */}
            <div className="footer-brand">
              <div className="footer-logo">
                <i className="fas fa-seedling"></i>
                <h3>FUWJALS</h3>
              </div>
              <p className="footer-description">
                Federal University Wukari Journal of Agriculture and Life Sciences
              </p>
              <p className="footer-tagline">
                Advancing knowledge in agriculture and life sciences through rigorous
                research and academic excellence.
              </p>
              <div className="footer-social">
                <a href="#" className="social-link" aria-label="Facebook">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="#" className="social-link" aria-label="Twitter">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="#" className="social-link" aria-label="LinkedIn">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="#" className="social-link" aria-label="ResearchGate">
                  <i className="fab fa-researchgate"></i>
                </a>
              </div>
            </div>

            {/* Links Sections */}
            <div className="footer-links">
              <h4>Journal</h4>
              <ul>
                {footerLinks.journal.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.title}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-links">
              <h4>For Authors</h4>
              <ul>
                {footerLinks.authors.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.title}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-links">
              <h4>Resources</h4>
              <ul>
                {footerLinks.resources.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.title}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-links">
              <h4>Policies</h4>
              <ul>
                {footerLinks.policies.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Contact Information */}
          <div className="footer-contact">
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <span>Federal University Wukari, PMB 1020, Wukari, Taraba State, Nigeria</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <a href="mailto:journal@fuwukari.edu.ng">journal@fuwukari.edu.ng</a>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone"></i>
              <span>+234 (0) 000 0000 000</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-bottom-content">
            <p>© {currentYear} Federal University Wukari Journal of Agriculture and Life Sciences. All rights reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy-policy">Privacy</Link>
              <span>•</span>
              <Link to="/terms">Terms</Link>
              <span>•</span>
              <Link to="/sitemap">Sitemap</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;